import applicantController from '../../../controllers/applicantController/controller';
import careerController from '../../../controllers/careerController/controller';
import Swal from 'sweetalert2';
// import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { EventBus } from '@/eventBus';

export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            periode: 'all',
            applicantList: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 0,
            totalApplicants: 0, // Total items dari backend
            searchQuery: '',
            fileUrl:'',
            fileName: '',
            applicant: {
                id_career: '',
                name_aplicant: '',
                email: '',
                no_hp: '',
                cv: '',
                status: ''
            },
            careerList: [],
            selectedApplicant: {
                id: '',
                name_aplicant: '',
                id_career: '',
                positions: '',
                email: '',
                no_hp: '',
                cv: '',
                status: '',
                updated_by: '',
                updated_by_name: '',
                updated_on: ''
            },
            isRecaptchaVisible: false,
            isRecaptchaVerified: false,
            recaptcha: null,
            gambarUrl: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/dokumen/cv/',
        };
    },
    computed: {
        filteredApplicants() {
            return this.applicantList.filter(applicant => applicant.name_aplicant.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalApplicants / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.selectedApplicant.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.selectedApplicant.updated_by_name = name;
            
        },
        showRecaptcha() {
          this.isRecaptchaVisible = true;
          this.$nextTick(() => {
            window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
              sitekey: "6LcPGP8qAAAAAHhi2i81rKfnV-OsQAN7NvXrbDIR",
              callback: this.onRecaptchaSuccess
            });
          });
        },
        onRecaptchaSuccess(response) {
          this.isRecaptchaVerified = true;
          this.recaptcha = response;
        },
        showModal(type, id) {
            this.user();
            const applicant = this.applicantList.find(applicant => applicant.id === id);
            if (applicant) {
                this.applicant = applicant;
                
                const modal = document.getElementById(type === 'edit' ? 'editApplicant' : 'detailApplicant');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahApplicant', 'editApplicant', 'detailApplicant'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchApplicants();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.applicant.name_aplicant = '';
            this.applicant.id_career = '';
            this.applicant.email = '';
            this.applicant.no_hp = '';
            this.applicant.cv = '';
            this.applicant.status = '';
            this.fileUrl = '';
            this.fileName = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchApplicants();
            }
        },
        async handleFileUpload(event) {
            try{
                const file = event.target.files[0];
                if (file) {
                    this.fileName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.fileUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan pilih file',
                        timer: 1500
                    })
                    return;
                }
    
                // Validasi tipe file (opsional)
                const allowedTypes = ['application/pdf'];
                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: 'Hanya file PDF yang diperbolehkan',
                        timer: 1500
                    })
                    return;
                }
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: `Ukuran file terlalu besar, maksimal ${allowedSize / 1024 / 1024} MB`,
                        timer: 1500
                    })
                    this.resetForm();
                    return;
                }
    
                this.applicant.cv = file;
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan' + error,
                    timer: 1500
                })
            }
        }, 
        async fetchApplicants() {
            try {
                const period = this.periode;
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await applicantController.fetchApplicant(period, query, this.currentPage, this.pageSize, company);
                this.applicantList = response.data;
                console.log(this.applicantList);
                this.totalAllApplicants();
                this.fetchCareer();
            } catch (error) {
                console.error('Error fetching applicants:', error);
                throw error;
            }
        },
        async fetchCareer(){
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await careerController.fetchCareers(query, this.currentPage, this.pageSize, company);
                this.careerList = response.data;
            } catch (error) {
                console.error('Error fetching careers:', error);
                throw error;
            }
        },
        async totalAllApplicants(search){
            try {
                const company = this.company;
                const sanitizedSearch = search && search.trim() !== '' ? search : null;
                const response = await applicantController.totalAllApplicants(sanitizedSearch, company);
                this.totalApplicants = response.data;
            } catch (error) {
                console.error('Error fetching applicants:', error);
                throw error;
            }
        },
        async addApplicant() {
            try {
                Swal.fire({
                    title: 'Loading...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                const tipe = 'Admin';
                const formData = new FormData();
                formData.append('name', this.applicant.name_aplicant);
                formData.append('career_id', this.applicant.id_career);
                formData.append('email', this.applicant.email);
                formData.append('no_hp', this.applicant.no_hp);
                formData.append('cv', this.applicant.cv);
                formData.append('status', '0');
                formData.append('id_company', this.company);
                formData.append('tipe', tipe);
                
                if(!this.applicant.name_aplicant || !this.applicant.id_career || !this.applicant.email || !this.applicant.no_hp || !this.applicant.cv){
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan isi semua data',
                        timer: 1500
                    })
                    return;
                }

                const response = await applicantController.addApplicant(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 200) {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Applicant berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchApplicants();
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Applicant gagal ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Applicant gagal ditambahkan',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        },        
        async updateApplicant() {
            try {
                const id = this.applicant.id;
                const name = this.applicant.name_aplicant;
                const status = this.applicant.status;
                const email = this.applicant.email;
                const updated_by = this.selectedApplicant.updated_by;
                const updated_by_name = this.selectedApplicant.updated_by_name;
                const note = this.selectedApplicant.tanggal ? this.selectedApplicant.tanggal : this.selectedApplicant.link;
                if (!id || !name || !status || !email || !updated_by || !updated_by_name ) {
                    throw new Error('Isi semua field!!');
                }
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' '); // Format MySQL
                const updateData = {id, name, status, updated_by, email, updated_by_name, updated_on, note};
                const response = await applicantController.updateApplicant(updateData);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Applicant berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchApplicants();
                    this.closeModal();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Applicant gagal diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Applicant gagal diperbaharui',
                    showConfirmButton: false,
                    timer: 1500
                })
                throw error;
            }
        },
        async deleteApplicant(applicantId, applicantCv) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    Swal.fire({
                        title: 'Loading...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const response = await applicantController.deleteApplicant(applicantId, applicantCv);
                    if (response.status === 200) {
                        this.fetchApplicants();
                        Swal.fire({
                            icon: 'success',
                            title: 'Applicant berhasil dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Gagal menghapus data',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            }
        },
        async handleStatusChange() {
            const selectedStatus = this.complaint.status;

            // Optional: bisa dihapus jika tidak dibutuhkan
            this.complaint.status = selectedStatus;

            const formFloatingElement = document.querySelector('.form-floating');
            const formFloatElement = document.querySelector('.form-float');

            if (selectedStatus === '1' || selectedStatus === '2' || selectedStatus === '3') {
                if (formFloatingElement) formFloatingElement.style.display = 'block';
                if (formFloatElement) formFloatElement.style.display = 'none';
            } else if (selectedStatus === '5') {
                if (formFloatingElement) formFloatingElement.style.display = 'none';
                if (formFloatElement) formFloatElement.style.display = 'block';
            } else {
                if (formFloatingElement) formFloatingElement.style.display = 'none';
                if (formFloatElement) formFloatElement.style.display = 'none';
            }
        },
        async downloadApplicantList(){
            const period = this.periode;
            const company = this.company;
            const response = await applicantController.downloadApplicantList(period, company);
            this.downloadExcell(response);
        },
        async downloadExcell(data) {
            const headers = [
                { header: "Nama Pelamar", key: "name" },
                { header: "Email", key: "email" },
                { header: "Telepon", key: "phone" },
                { header: "Posisi", key: "positions" },
                { header: "CV", key: "cv" },
            ];

            // Buat workbook & worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Daftar Pelamar");

            // Tambahkan judul laporan
            worksheet.mergeCells("A1:F1");
            worksheet.getCell("A1").value = "Laporan Daftar Pelamar";
            worksheet.getCell("A1").font = { size: 16, bold: true };
            worksheet.getCell("A1").alignment = { horizontal: 'center' };

            // Spasi baris kosong
            worksheet.addRow([]);

            // Tambahkan header
            worksheet.addRow(headers.map(h => h.header));

            // Tambahkan data
            data.forEach(item => {
                worksheet.addRow(headers.map(h => item[h.key]));
            });

            // Styling: Bold header + border
            const headerRow = worksheet.getRow(3);
            headerRow.eachCell(cell => {
                cell.font = { bold: true };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });

            // Border untuk semua data
            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber >= 3) {
                    row.eachCell(cell => {
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' },
                        };
                        cell.alignment = { vertical: 'middle', horizontal: 'left' };
                    });
                }
            });

            // Tambah tempat tanda tangan
            const lastRowNum = worksheet.lastRow.number + 3;
            worksheet.getCell(`E${lastRowNum}`).value = "Mengetahui,\nHRD";
            worksheet.getCell(`E${lastRowNum}`).alignment = { horizontal: 'center', wrapText: true };
            worksheet.mergeCells(`E${lastRowNum}:F${lastRowNum + 2}`);

            // Auto width kolom
            headers.forEach((h, index) => {
                worksheet.getColumn(index + 1).width = h.header.length + 5;
            });

            // Simpan file
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), "Laporan Pelamar.xlsx");
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted (){
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchApplicants'
        },
        company: {
            handler: 'fetchApplicants'
        }
    },
}